<template>
	<div v-show="bodyIsShow">
		<input type="hidden" id="abTestFlag" :value="abTestFlag">
		<section v-if="(periods.successBannerList.length>0) && (periods.successBannerCb==true)">
     		<mt-swipe :auto="4000">
			  <mt-swipe-item v-for="(item,index) in periods.successBannerList">
			  	<a v-if="item.text" :href="item.text">
			  		<img style="width:100%" :class="['swiper-img',{'trackEvent':((periods.cityId == 170) && index==0)}]" data-track="carfestivalDetail-10-linkToAd-detail" :src="commmonWebConfig.picHost+periods.picUrl+item.imageName">
			  	</a>
			  	<img v-else style="width:100%" :class="['swiper-img',{'trackEvent':((periods.cityId == 170) && index==0)}]" data-track="carfestivalDetail-10-linkToAd-detail" :src="commmonWebConfig.picHost+periods.picUrl+item.imageName">
			  </mt-swipe-item>
			</mt-swipe>
		</section>
		<section>
			<div class="perfectwrap">
						<div v-if="periods.improveInfoTextFlag==1" class="addtext">{{periods.improveInfoText}}</div>
						<div v-if="periods.improveInfoPicFlag==1" class="addimgwrap">
							<img :src="periods.improveInfoPic" alt="" />
						</div>
				<div>
					<div v-if="(isTicket == 1 ||  isTicket == 2) && address == 1" class="sinform addresscommon">
						<em class="signUpfrom-icon signUpfrom-icon02"></em>
						<input type="text" class="sinform-text" name="address" placeholder="请输入门票收件地址"  id="address">
					</div>
					<div v-if="car && car == 0" class="sinform">
						<em class="icon-arror-l"></em>
						<div class="sinform-text" id="insertCar">请选择意向品牌或车型</div>
						<div class="icon-arror-r"></div>
					</div>
				</div>
				<div class="seleoverall">
					<div class="selectwrap">
						<span class="shopcartype">旧车是否售卖</span>
					</div>
					<div class="caritem clearfix" id="index-cartype">
						<ul v-if="buyList.length>0" >
							<li  v-for="(item,index) in buyList" :data-buyType="item.value">{{item.name}}</li>
						</ul>
					</div>
				</div>
				<div v-if="instalments==1" class="seleoverall">
					<div class="selectwrap">
						<span class="shopcartype">是否分期</span>
					</div>
					<div class="caritem clearfix" id="index-bystages">
						<ul>
							<li data-splitMoney="0" @click="stages($event)">全款</li>
							<li data-splitMoney="1" @click="stages($event)">分期</li>
						</ul>
					</div>
				</div>
				<div v-show="schemeList&&scheme" :class="[{ move: isActive },'seleoverall']">
					<div :class="[{ move: isActive },'selectwrap']">
						<span class="shopcartype">{{schemeList.title}}</span>
					</div>
					<div class="caritem clearfix" id="index-scheme">
						<ul>
							<li  v-for="(item,index) in schemeList.optionList" :data-schemeId="schemeList.optionList[index].valId">{{schemeList.optionList[index].descInfo}}</li>
							<!-- <li data-splitMoney="1">applyOptionList[1].optionList[index].descInfo</li> -->
						</ul>
					</div>
				</div>
				<!--购车小计划-->
			   <div class="projectwrap clearfix">
					  <div class="proTit">
					  	<img class="proTcon" :src="commmonWebConfig.static + applyOptionList.icon" />
					    	{{applyOptionList.title}}
					  </div>
					  <ul class="checkitem clearfix">
					     <li v-for="(itemValue,indexValue) in applyOptionList.optionList"  :class="[{'redsizeActive':itemValue.active}]" @click="selects(indexValue)">
					     	<em class="redwrap" style="width:0.2rem; display:inline-block;">
					     		 <em class="redok" v-show="itemValue.active"></em>
					     	</em>
					           {{itemValue.descInfo}}
					      </li>
					     
					  </ul>
					  <div class="proredArror"></div>
				</div>
				<!--购车小计划-->
				<div id="submitBtn" @click="submit()" class="submit1">
					提交
				</div>
			</div>	
		</section>
		<section>
			<div class="whyselect clearfix">
				<div class="line1"></div>为什么选择团车<div class="line2"></div>
     			<div class="pldge-wrap clearfix">
					<div class="promise1 promise  bigline btnline">
						<em class="icon01"></em>
						<div class="rightbox">
							<div class="title">积淀深厚</div>
							<div class="center">2010年成立,2017年</div>
							<div class="size-btn">为用户至少节省20亿</div>
						</div>
					</div>
					<div class="promise2 promise btnline">
						<em class="icon02"></em>
						<div class="rightbox">
							<div class="title">覆盖全面</div>
							<div class="center">百城覆盖,超过百家汽车</div>
							<div class="size-btn">品牌曾参展团车节</div>
						</div>
					</div>
					<div class="promise3 promise bigline">
						<em class="icon03"></em>
						<div class="rightbox">
							<div class="title">车源优质</div>
							<div class="center">全国8000家4S店与主机</div>
							<div class="size-btn">厂的长期合作确保正品</div>
						</div>
					</div>
					<div class="promise4 promise">
						<em class="icon04"></em>
						<div class="rightbox">
							<div class="title">价格优惠</div>
							<div class="center">百余城范围询价

</div>
							<div class="size-btn">确保优惠</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!--新增弹窗s-->
		<div class="addPopwrap clearfix" v-show="isaddPopwrap" style="margin-top:-6.5rem;">
			<div class="closepop" @click="closeLink"></div>
			<img  class="addbanner fl" :src='commmonWebConfig.static+"/img/carfestival/maskbanner.png"' alt="" />
			<div class="contentwrap">
			<div class="tipText">您可以按照以下步骤关注“团车”</div>
			<div class="bigicon">
				<img :src='commmonWebConfig.static+"/img/carfestival/pubicon.png"' alt="" />
			</div>
		</div>
		</div>
		<div class="popUp" v-show="isLading"></div>
        <!--新增弹窗end-->
		 <!--侧拉品牌--> 
		<div class="sider-mark" id="sider-mark"></div>
		<div class="sider-wrap" id="sider-wrap">
			<div id="side-brand" class="side-div side-brand">
			</div>
			<div id="side-carstyle" class="side-div side-carstyle">
			</div>
		</div>
	</div>
</template>

<style scoped lang="less">
	@import "../../assets/less/common.less";
	.mint-swipe{
		height:5.33333rem;
	}
	.perfectwrap .selectwrap{
		padding-top:0.4rem;
		margin-top: 0;
	}
	.perfectwrap .submit1 {
	    height: 1.04rem;
	    line-height: 1.04rem;
	    background-color: #ff3838;
	    text-align: center;
	    color: #fff;
	    margin: 0 0.266666rem;
	    font-size: 16px;
	    border-radius: 0.1rem;
	    margin-top: 0.533333rem;
	}
	.move{
		height:0;
		padding:0;
		margin:0;
	}
</style>
<script>
import { Toast } from 'mint-ui';
export default {
	name: 'perfect',
	data:function() {
		return {
			bodyIsShow:true,
//			showOk:false,
			periods:{
				cityId:10,
				successBannerList:[],
				// 已换成真实数据
				improveInfoTextFlag:1,
				// 已换成真实数据
				improveInfoText:"",
				// 已换成真实数据
				improveInfoPicFlag:1,
				// 已换成真实数据
				improveInfoPic:"",
				successBannerCb:false,
				picUrl:""
			},
			abTestFlag:null,
			// 已换成真实数据
			isTicket:null,
			address:null,
			// 已换成真实数据;
			car:null,
			buyway:1,
			buyList:[],
			// 已换成真实数据
			instalments:1,
			isaddPopwrap:false,
			isLading:false,
			showWeiXinValue:'',
			applyOptionList:{},
			schemeList:{
				optionList:[]
			},
			optionList:[],
			valId:'',
			scheme:false,
			schemeIdValue:'',
			isActive:false
		}
	},
	beforeCreate:function(){
		getCommonJsIns.initCSS({
			cssURL:"/css/carfestival/perfectmsg.css"
		});
	},
	mounted:function(){
		var self = this;
		document.title="报名成功";
	    window.cityId = self.$route.query.cityId;
	    self.periods.cityId =  self.$route.query.cityId;
		getCommonJsIns.initDefaultJS(self.webReady);
		(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
	            (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
	        m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
	    })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
	    ga('create', 'UA-28316522-1', 'auto');
	    ga('send', 'pageview');
	    /***统计添加**/
		!function(e, t, n, g, i) {
		    e[i] = e[i] || function() { 
		    	(e[i].q = e[i].q || []).push(arguments)
		    };
		    var n = t.createElement("script");
		    var tag = t.getElementsByTagName("script")[0];
		    n.async = 1;
		    n.src = ('https:' == document.location.protocol ? 'https://': 'http://') + g;
		    tag.parentNode.insertBefore(n, tag);
		} (window, document, "script", "assets.growingio.com/2.1/gio.js", "gio");
		gio('init', '8004d11f5708cccc', {});
		gio('send');
		gio('enableHT', 'true');
		/***统计添加**/
	},
	methods:{
		webReady:function(){
			 // 备份this
			 var self = this;
			 this.bodyIsShow = true;
		     self.getapplyOptionList();//购车小计划
			 var str = (window.location.href).substr((window.location.href).indexOf("?"));
			 self.ajaxSubmit.ajax({
				url:self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.applySupplement + str,
				type:"get",
				data:{},
				success:function(data){
					getCommonJsIns.loadJs(self.commmonWebConfig.static + "/js/app/carfestival/perfectmsg.js",function(){});
					//数据保存
					 var result = data.response.result.periods;
					 var overall = data.response.result;
					// 判断数据请求状态
					 if (data.responseHeader.status==200) {
					 	self.showWeiXinValue=data.response.result.showWeiXin;
					 	console.log(self.showWeiXinValue);
					 	self.periods.successBannerCb = result.successBannerCb;
					 	for(var i in result.successBannerList){
					 		self.periods.successBannerList.push(result.successBannerList[i]);
					 	}
				        self.periods.improveInfoTextFlag = result.improveInfoTextFlag;
				        self.periods.improveInfoText = result.improveInfoText;
				        self.periods.improveInfoPicFlag = result.improveInfoPicFlag;
			            self.periods.improveInfoPic = result.improveInfoPic;
			            self.periods.picUrl =  result.picUrl;
			            if(overall.abTestFlag){
			            	self.abTestFlag = overall.abTestFlag;
			            	console.log(self.abTestFlag);
			            }

			            if(overall.address){
			            	self.address = overall.address;
			            	console.log(self.address);
			            }

			            if(overall.car){
			            	self.car = overall.car;
			            	console.log(self.car);
			            }
			            self.isTicket = overall.isTicket;
			            self.instalments = overall.instalments;
					 }
				},
				error:function(){}
			});
			self.ajaxSubmit.ajax({
				url:self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.buyWays,
				type:"get",
				data:{
					cityId : self.$route.query.cityId
				},
				success:function(data){
					// 判断数据请求状态
					 if (data.responseHeader.status==200) {
					 	self.buyList = data.response.result;
					 }
				},
				error:function(){}
			});
		},
		stages:function(event){
			var self=this;
			console.log(event,"event");
			if(event.srcElement.dataset.splitmoney==1){
				self.scheme=true;
			}else{
				self.scheme=false;
			}
			
		},
		getapplyOptionList:function(){
			var self=this;
			 self.ajaxSubmit.ajax({
				url:self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.applyOptionList,
				// url:'//172.16.3.154:8280/adConfigApi/tcj/applyOptionList',
				type:"get",
				data:{
					cityId : self.$route.query.cityId,
					pageType:1
				},
				success:function(data){
					// 判断数据请求状态
					 if (data.responseHeader.status==200){
					 	if(data.response.result[0]){
							// console.log(data.response.result[0],5555555555555555555555555);
							  self.applyOptionList=data.response.result[0];
							  if(self.applyOptionList){
								for(var itemIndex in self.applyOptionList.optionList) {
									self.$set(self.applyOptionList.optionList[itemIndex], "active", false);
								}
							}
						 }
						 if(data.response.result[1]){
							  self.schemeList=data.response.result[1];
							  if(self.schemeList){
								for(var itemIndex in self.schemeList.optionList) {
									self.$set(self.schemeList.optionList[itemIndex], "active", false);
								}
							}
					 	}else{
							 self.isActive=true;
							 self.schemeList={};
						 }
				        
					 }else{
					   console.log('请求失败');
					 }
				},
				error:function(){
					  console.log('error');
				}
			});
		},
		selects:function(itemIndex){
			var self = this;
			for(var optionIndex in self.applyOptionList.optionList) {
					self.$set(self.applyOptionList.optionList[optionIndex], "active", false)
					self.applyOptionList.optionList[optionIndex].active = false;
			 }
				var optionObj = this.applyOptionList.optionList[itemIndex];
				optionObj.active = !optionObj.active;
                self.valId=optionObj.valId;
				this.applyOptionList.optionList[itemIndex] = optionObj;
		},
		submit:function(){
			var self = this;
			$("#submitBtn").attr("disabled","disabled");
			var relF = $("#side-carstyle").data("dada");
			if((!relF || relF == "") && $("#insertCar").size() > 0) {
				Toast({
                  message: "请选择品牌或车型",
                  position: 'middle',
                  duration: 2000
                });
			}else if($("#address").val() ==""){
				Toast({
                  message: "请输入门票地址",
                  position: 'middle',
                  duration: 2000
                });
			} else {
				var rel;
				if(typeof(relF) != "undefined"){
					rel = relF.split("@#");
				}
				var sinData = {};
				if(self.$route.query.sk){
					sinData["sk"] = self.$route.query.sk;
				};
				sinData['applyId'] = this.$route.query.applyId;
				sinData['groupbyNum'] = this.$route.query.periodsId;
				sinData['buyType'] = $("#index-cartype").find('.active').attr("data-buytype");
				sinData['splitMoney'] = $("#index-bystages").find('.active').attr("data-splitmoney");
				self.schemeIdValue = $("#index-scheme").find('.active').attr("data-schemeId");
				if(typeof(relF) != "undefined") {
					sinData['brandId'] = rel[0];
					sinData['carStyleId'] = rel[1];
					sinData['noCheckBrandStyle'] = 0;
				} else {
					sinData['noCheckBrandStyle'] = 1;
				}
				var addressId = $("#address").val();
				if(addressId) {
					sinData['paperTicketAddress'] = $("#address").val();
				}
//				购车小计划
				// if(self.schemeIdValue&&self.valId){
				// 	sinData.valIds=self.valId+','+self.schemeIdValue;
				// }else if(self.valId){
				// 	sinData.valIds=self.valId;
				// }else if(self.schemeIdValue){
				// 	sinData.valIds=self.schemeIdValue;
				// }
				var valueTeam=[];
				if(self.valId){
					valueTeam.push(self.valId);
				}
				if(self.schemeIdValue){
					valueTeam.push(self.schemeIdValue);
				}
				sinData['valIds'] = valueTeam.join(",");
				self.ajaxSubmit.ajax({
					url:self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.supplementForM,
					// url:'//172.16.3.154:8280/adConfigApi/tcj/supplementForM',
					type:"post",
					data:sinData,
					success:function(data){
						$("#submitBtn").removeAttr("disabled");
						   if(data.responseHeader.status == 200){
							//     if(self.showWeiXinValue == 1){
							// 	   self.isLading=true;//蒙层
							// 	   self.isaddPopwrap=true;//显示公众号弹窗
				            //    }else if(self.showWeiXinValue == 0){
					        self.isaddPopwrap=false;//不显示公众号弹窗
					        window.location.href = context + "/hmtcj/suc?applyId=" + self.$route.query.applyId + "&periodsId=" + self.$route.query.periodsId + "&t=" + Date.parse(new Date());
					            // } 
						}else{
							alert("请求失败");
						}
					},
					error:function(){
						$("#submitBtn").removeAttr("disabled");
						Toast({
		                  message: "系统忙，请稍后",
		                  position: 'middle',
		                  duration: 2000
		                });
					}
				});
			}
		},
		closeLink:function(){
			var self=this;
		    self.isaddPopwrap=false;
		    self.isLading=false;
				window.location.href = context + "/hmtcj/suc?applyId=" + self.$route.query.applyId + "&periodsId=" + self.$route.query.periodsId + "&t=" + Date.parse(new Date());
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/views/carfestival/perfect.vue